import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { FileUpload } from 'primereact/fileupload';

// eslint-disable-next-line react/display-name
export const WrappedFileUpload = forwardRef((props, ref) => {
	const { className = '', dataqa, disabled, ...rest } = props;

	const fileUploader = useRef();

	useImperativeHandle(ref, () => ({
		clear: () => {
			fileUploader.current.clear();
		},
	}));

	return (
		<div
			className={`common-ui-fileupload ${className} ${disabled ? 'p-disabled' : ''}`}
			data-qa={`ui-fileupload-${dataqa}`}
		>
			<FileUpload ref={fileUploader} disabled={disabled} {...rest} />
		</div>
	);
});

WrappedFileUpload.propTypes = {
	// Name of the request parameter to identify the files at backend.
	name: PropTypes.string,

	// Label of the choose button.
	chooseLabel: PropTypes.string,

	// Defines the UI of the component, possible values are "advanced" and "basic".
	mode: PropTypes.string,

	// Style class of the component.
	className: PropTypes.string,

	// Pattern to restrict the allowed file types such as "image/*".
	accept: PropTypes.string,

	// When enabled, upload begins automatically after selection is completed.
	auto: PropTypes.bool,

	// Event: Callback to invoke when file upload is complete.
	onSelect: PropTypes.func,

	// Whether to use the default upload or a manual implementation defined in uploadHandler callback.
	customUpload: PropTypes.bool,

	// Callback to invoke in custom upload mode to upload the files manually.
	uploadHandler: PropTypes.func,

	// For QA automation testing.
	dataqa: PropTypes.string,
};
